/**
 * Normalize privacy links in agreement HTML to use app base path.
 * Handles variants returned by the API:
 *   href="privacy"         href='/privacy'
 *   href="privacy/"        href="privacy.html"
 *   href="/privacy.html"
 *   href="&quot;privacy/&quot;"  (entity-encoded quotes wrapping the value)
 * @param html - The HTML string from API
 * @param privacyLinkPath - The target privacy link path (e.g., /v2/privacy)
 * @returns Normalized HTML with corrected privacy links
 */
export const normalizeAgreementLinks = (
  html: string,
  privacyLinkPath: string,
): string => {
  return (
    html
      // Standard: href="privacy", href="/privacy", href="privacy/", href="privacy.html", href="/privacy.html"
      .replace(
        /href\s*=\s*(['"])(?:\/)?privacy(?:\.html|\/)?\1/gi,
        `href="${privacyLinkPath}"`,
      )
      // Entity-encoded quotes wrapping the value: href="&quot;privacy/&quot;" → renders as "privacy/" in URL
      .replace(
        /href\s*=\s*(['"])&quot;(?:\/)?privacy(?:\.html|\/?)?&quot;\1/gi,
        `href="${privacyLinkPath}"`,
      )
  );
};
